/**
  @module @ember-data/serializer
*/
import { Transform } from './-private';
export default Transform;